import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@nuxtjs/composition-api';
import { computed, ref, watch } from 'vue';

interface Props {
  categories?: any[];
  features?: any[];
  products?: any[];
  totalPagesCount?: number;
  loading?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsCatalog',
  props: {
    categories: null,
    features: null,
    products: null,
    totalPagesCount: null,
    loading: { type: Boolean }
  },
  emits: ["fetch"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'fetch', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  categories?: any[];
  features?: any[];
  products?: any[];
  totalPagesCount?: number;
  loading?: boolean;
};



const route = useRoute();
const productList = ref<any>(null);

const filter = ref<any[]>([]);
const filterRoute = computed(() => route.value.query.categories as string);
if (filterRoute.value)
  filter.value.push(
    ...filterRoute.value
      .slice()
      .split(',')
      .map((i) => Number(i)),
  );

const featuresFilters = ref<any[]>([]);
const featuresRoute = computed(() => route.value.query.features as string);
if (featuresRoute.value)
  featuresFilters.value.push(
    ...featuresRoute.value
      .slice()
      .split(',')
      .map((i) => Number(i)),
  );

const activeFiltersLength = computed(
  () => filter.value.length + featuresFilters.value.length,
);

const isCatalogFiltersVisible = computed(
  () => props.categories?.length || props.features?.length,
);

const clearFilter = () => {
  filter.value = [];
  featuresFilters.value = [];
};

const filterDrawerState = ref(false);
const toggleFilterDrawerState = () => {
  filterDrawerState.value = !filterDrawerState.value;
};

const productsPerRow = computed(() => {
  return props.categories?.length ? 3 : 4;
});

const currentPage = computed(() => route.value.query.page);

const filterProducts = (
  categories: any[],
  features: any[],
  page?: string | (string | null)[],
) => {
  emit('fetch', { categories, features, page });
  productList.value?.scrollIntoView({
    alignToTop: true,
    behavior: 'smooth',
  });
};

const applyFilterProducts = () => {
  toggleFilterDrawerState();
};

watch(currentPage, (newValue) => {
  filterProducts(filter.value, featuresFilters.value, newValue);
});

watch(
  [filter, featuresFilters],
  ([newFilter, newFeaturesFilters], [oldFilter, oldFeaturesFilters]) => {
    if (
      JSON.stringify(newFilter) === JSON.stringify(oldFilter) &&
      JSON.stringify(newFeaturesFilters) === JSON.stringify(oldFeaturesFilters)
    )
      return;

    filterProducts(newFilter, newFeaturesFilters);
  },
);

// const currentSorting = ref(true);

// const sortProducts = () => {
//   currentSorting.value = !currentSorting.value;
//   const values = new Map();
//   values.set(true, 'asc');
//   values.set(false, 'desc');
//   emit(
//     'fetch',
//     filter.value,
//     currentPage.value,
//     values.get(currentSorting.value),
//   );
// };

return { __sfc: true,props, emit, route, productList, filter, filterRoute, featuresFilters, featuresRoute, activeFiltersLength, isCatalogFiltersVisible, clearFilter, filterDrawerState, toggleFilterDrawerState, productsPerRow, currentPage, filterProducts, applyFilterProducts }
}

})